import {useTranslation} from '@aboutyou/i18n';
import {FadeTransition} from '@aboutyou/transitions';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_WEIGHTS} from '../../../constants/typography';
import {UnstyledButton} from '../../atoms/Buttons/UnstyledButton';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

export const MerchantInfo = ({
  rows,
  className,
  onInfoClick,
  showBorderRadius = false,
}: {
  rows: string[];
  className?: string;
  onInfoClick?: VoidFunction;
  showBorderRadius?: boolean;
}) => {
  const {t} = useTranslation();
  return (
    <FadeTransition duration={500}>
      <MerchantInfoWrapper
        data-testid="merchantInfoWrapper"
        className={className}
        $showBorderRadius={showBorderRadius}
      >
        <StyledIcon
          asset={GenericIconName.Merchant}
          size={'XS'}
          fill={COLORS.Grey0}
        />
        <ContentWrapper>
          {rows.map((row, index) => {
            return (
              <RowWrapper key={`merchantInfo-row-${index}`}>
                <div dangerouslySetInnerHTML={{__html: row}} />
                {index === 0 && (
                  <UnstyledButton
                    onClick={onInfoClick}
                    data-testid="merchantInfoInfoIcon"
                    aria-label={t('Open merchant info window')}
                  >
                    <StyledIcon asset={GenericIconName.Info} size={'XSS'} />
                  </UnstyledButton>
                )}
              </RowWrapper>
            );
          })}
        </ContentWrapper>
      </MerchantInfoWrapper>
    </FadeTransition>
  );
};

const RowWrapper = styled.div`
  display: flex;
  gap: 5px;
  line-height: 18px;
  align-items: center;

  span {
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MerchantInfoWrapper = styled.div<{$showBorderRadius: boolean}>`
  display: flex;
  background-color: ${COLORS.Grey5};
  color: ${COLORS.Grey0};
  font-size: 12px;
  padding: 10px 20px;
  gap: 10px;
  align-items: center;

  ${props => (props.$showBorderRadius ? 'border-radius: 4px;' : '')}
`;

const StyledIcon = styled(Icon)`
  fill: ${COLORS.Grey0};
  cursor: pointer;
`;
